import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
//css
import './timeline.css';
//components
import PaymentSummary from './paymentSummary/PaymentSummary';
import PaymentTimeline from './paymentTimeline/PaymentTimeline';

export default function TimelineView() {
    const location = useLocation();
    const navigate = useNavigate();
    const { paymentInfo, transactions, authToken } = location.state || [];

    if (!paymentInfo || paymentInfo === null) {
        navigate("/");
    }

    const handleCancelButtonClick = (e) => {
        e.preventDefault();
        navigate("/result", { state: { transactions: transactions, authToken: authToken } });
    }

    return (
        <>
            {paymentInfo && <div className='timeline-transaction-data-container'>
                <div className='timeline-container'>
                    <PaymentSummary
                        currency={paymentInfo.currency}
                        amount={paymentInfo.amount}
                        status={paymentInfo.status}
                        paymentType={paymentInfo.paymentMethod}
                        tokenNumber={paymentInfo.token}
                    />
                    <PaymentTimeline timelines={paymentInfo.timelines} />
                </div>
                <div id='modal-container'></div>
            </div>}
            <div className='cancel-button-container'>
                <button className='cancel-button' onClick={handleCancelButtonClick}>Back</button>
            </div>
        </>
    )
}